import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionsService } from './permissions.service';

@Directive({
    selector: '[permission]',
    standalone: true,
})
export class PermissionsDirective {
    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private permissionsService: PermissionsService
    ) {}

    @Input() set permission(permission: string) {
        if (!permission) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            return;
        }
        if (this.permissionsService.hasPermission(permission)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
